import { render, staticRenderFns } from "./SaasView.vue?vue&type=template&id=b25e2fa2"
import script from "./SaasView.vue?vue&type=script&lang=js"
export * from "./SaasView.vue?vue&type=script&lang=js"
import style0 from "./SaasView.vue?vue&type=style&index=0&id=b25e2fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports